import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Passenger } from '../../../data/models/passenger.model';

import { useCanReadPassengers } from '../../../hooks/permissions/useCanReadPassengers';
import { useCanReadTripInventory } from '../../../hooks/permissions/useCanReadTripInventory';
import { useIsClientPortalUser } from '../../../hooks/useIsClientPortalUser';
import { useIsClientPortalAdminUser } from '../../../hooks/useIsClientPortalAdminUser';
import { useIsSuperReaderUser } from '../../../hooks/permissions/useIsSuperReaderUser';
import { useIsPR2User } from '../../../hooks/permissions/useIsPR2User';

import PageHeader from '../../controls/PageHeader';

interface ReservationDetailsHeaderProps {
  passenger: Passenger;
  onEdit: () => void;
}

const ReservationDetailsHeader = ({
  passenger,
  onEdit,
}: ReservationDetailsHeaderProps) => {
  const { t } = useTranslation('common');
  const { passengerId, referenceId } = useParams<{
    passengerId: string;
    referenceId: string;
  }>();

  const canViewPassengers = useCanReadPassengers();
  const canViewTripInventory = useCanReadTripInventory();
  const isClientPortalUser =
    useIsClientPortalUser() || useIsClientPortalAdminUser();
  const isSuperReaderUser = useIsSuperReaderUser();
  const isPR2User = useIsPR2User();

  let returnLink;
  let returnLinkText;
  if (canViewPassengers || isClientPortalUser) {
    returnLink = `/passengers/${passengerId}`;
    returnLinkText = `${passenger?.firstName} ${passenger?.lastName}`;
  } else if (canViewTripInventory && !isPR2User) {
    returnLink = '/triplegs';
    returnLinkText = t('navigation.tripManagement');
  } else {
    returnLink = '/';
    returnLinkText = t('navigation.home');
  }

  return (
    <PageHeader
      title={`${t('reservation.reservation')} ${referenceId}`}
      returnLink={returnLink}
      returnLinkText={returnLinkText}
      primaryActionText={!isSuperReaderUser ? t('common.edit') : undefined}
      onPrimaryAction={!isSuperReaderUser ? onEdit : undefined}
    />
  );
};

export default ReservationDetailsHeader;
